"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSettingsNotFoundException = void 0;
const http_exception_1 = require("./http.exception");
class PaymentSettingsNotFoundException extends http_exception_1.HttpException {
    constructor(id) {
        super(404, `Payment settings with id ${id} not found`);
    }
}
exports.PaymentSettingsNotFoundException = PaymentSettingsNotFoundException;
//# sourceMappingURL=paymentSettingsNotFound.exception.js.map